/**
 * Module: DeferLoadingHelper
 *
 * Calls Utility.isElementInViewIO in order to add Deferloading
 *
 *
 * Returned Functions: Init
 *
 * CallBack Function sent to IsElementInViewIO
 *
 * 1.loadImage
 * 2.loadPicture
 *
 */

var Acr = Acr || {};

Acr.DeferLoadingHelper = (function () {
  

  function loadImages() {

    var imagesToLoad = [].slice.call(document.querySelectorAll('img.defer'));

    imagesToLoad.forEach(function (element) {
      if (element.dataset.srcset !== undefined) {
        element.srcset = element.dataset.srcset;
      }
      element.src = element.dataset.src;
      element.classList.remove('defer');
    });

  }

  function loadPictures() {

    var picturesToLoad = [].slice.call(document.querySelectorAll('picture.defer'));

    picturesToLoad.forEach(function (pictureElement) {

      var elementChildren = [].slice.call(pictureElement.querySelectorAll('source,img'));

      elementChildren.forEach(function (elementChild) {

        if (elementChild.dataset.srcset) {
          elementChild.setAttribute('srcset', elementChild.dataset.srcset);
        }

        if (elementChild.dataset.src) {
          elementChild.setAttribute('src', elementChild.dataset.src);
        }
      });

      pictureElement.classList.remove('defer');
    });

    if (Utility.isIE11()) {
      Utility.reevaluatePictureFill();
    }

  }

  function loadVideos() {
    var videosToLoad = [].slice.call(document.querySelectorAll('video.defer'));

    videosToLoad.forEach(function (videoElement) {
      var videoSources = [].slice.call(videoElement.querySelectorAll('source'));
      var posterSource = videoElement.dataset.poster;
      if (posterSource) {
        videoElement.setAttribute('poster', posterSource);
      }
      videoSources.forEach(function (videoSource) {
        if (videoSource.dataset.src) {
          videoSource.setAttribute('src', videoSource.dataset.src);
        }
      });
      videoElement.classList.remove('defer');
      videoElement.load();
    });
  }

  function init() {

    Utility.initDeferLoading(function () {
      loadImages();
      loadPictures();
      loadVideos();
    });

  }

  return {
    init: init,
  };
}());
